import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, FormSpy } from 'react-final-form';
import { PaymentsInsuranceFieldsWrapper } from '@unite-us/app-client-profile';
import * as apiHooks from 'src/api/APIHooks';
import {
  mapFormValuesToWrapperFormat,
  syncWrapperValuesToParentForm,
} from './utils/paymentsInsuranceValueMapping';

const noopSetFormErrors = () => {};

const INITIAL_VALUE_KEYS = [
  'plan_type',
  'plan_id',
  'external_member_id',
  'external_group_id',
  'enrolled_at_converted',
  'expired_at_converted',
];

const getValuesForComparison = (obj) => INITIAL_VALUE_KEYS.map((key) => obj?.[key]);

const areInitialValuesEqual = (prevValues, nextValues) => {
  const prevValuesForComparison = getValuesForComparison(prevValues);
  const nextValuesForComparison = getValuesForComparison(nextValues);
  return JSON.stringify(prevValuesForComparison) === JSON.stringify(nextValuesForComparison);
};

function PaymentsInsuranceFieldsContainerInner({
  fieldPrefix,
  form: parentForm,
  currentValues,
  initialValues,
  submitFailed,
  index,
}) {
  const nestedFormRef = useRef(null);

  const wrapperInitialValues = mapFormValuesToWrapperFormat(currentValues);
  const hasMeaningfulData = Object.values(initialValues || {}).some(
    (v) => v != null && v !== '',
  );
  const isEditing = hasMeaningfulData;

  useEffect(() => {
    if (submitFailed && nestedFormRef.current) {
      nestedFormRef.current.submit();
    }
  }, [submitFailed]);

  const handleFormValuesChange = useCallback(
    (payload) => {
      syncWrapperValuesToParentForm(fieldPrefix, parentForm, payload.values);
    },
    [fieldPrefix, parentForm],
  );

  return (
    <div className="payments-insurance__information">
      <Form
        initialValues={wrapperInitialValues}
        initialValuesEqual={areInitialValuesEqual}
        onSubmit={() => {}}
        render={({ values, form }) => {
          nestedFormRef.current = form;
          return (
            <>
              <FormSpy onChange={handleFormValuesChange} subscription={{ values: true }} />
              <div className="payments-insurance-fields">
                <PaymentsInsuranceFieldsWrapper
                  form={form}
                  isEditing={isEditing}
                  setFormErrors={noopSetFormErrors}
                  values={values}
                  hooks={apiHooks}
                  idPrefix={index != null ? `insurance-${index}` : undefined}
                />
              </div>
            </>
          );
        }}
      />
    </div>
  );
}

PaymentsInsuranceFieldsContainerInner.propTypes = {
  currentValues: PropTypes.object,
  fieldPrefix: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
  submitFailed: PropTypes.bool,
  index: PropTypes.number,
};

PaymentsInsuranceFieldsContainerInner.defaultProps = {
  currentValues: {},
  initialValues: {},
  submitFailed: false,
  index: null,
};

export default PaymentsInsuranceFieldsContainerInner;
